import { Badge } from '@mantine/core';
import { BookingResponseModel } from '../../../../types/BookingModels';
import { primaryColor } from '../../../../constants/theme';

export const getBookingStatusBadge = (
  bookingResponseModel: BookingResponseModel
) => {
  const {
    isCancelled,
    rejected: isRejected,
    accepted: isAccepted,
    startIso,
    endIso,
    paymentStatus,
  } = bookingResponseModel;
  const isInFuture = new Date(startIso) > new Date();

  if (isCancelled) {
    return (
      <Badge
        color="red"
        variant="outline"
        data-testid={`booking-cancelled-text-${bookingResponseModel.id}`}
      >
        Cancelled
      </Badge>
    );
  }

  if (isRejected) {
    return (
      <Badge color="red" variant="outline">
        Rejected
      </Badge>
    );
  }

  if (
    isAccepted &&
    paymentStatus === 'pending' &&
    !isCancelled &&
    !isRejected &&
    isInFuture
  ) {
    return (
      <Badge
        color={'orange'}
        variant="outline"
        data-testid={`text-confirmed-${bookingResponseModel.id}`}
      >
        Payment Pending
      </Badge>
    );
  }

  if (isAccepted && isInFuture && !isCancelled) {
    return (
      <Badge
        color={primaryColor}
        variant="outline"
        data-testid={`text-confirmed-${bookingResponseModel.id}`}
      >
        Accepted
      </Badge>
    );
  }

  if (!isAccepted && !isRejected && isInFuture) {
    return (
      <Badge
        color={'orange'}
        variant="outline"
        data-testid={`text-pending-${bookingResponseModel.id}`}
      >
        Pending
      </Badge>
    );
  }

  if (
    isAccepted &&
    paymentStatus !== 'pending' &&
    new Date(startIso) > new Date() &&
    new Date(endIso) < new Date() &&
    !isCancelled
  ) {
    return (
      <Badge color="blue" variant="outline">
        In Progress
      </Badge>
    );
  }

  if (isAccepted && new Date(endIso) < new Date() && !isCancelled) {
    return (
      <Badge color="gray" variant="outline">
        Completed
      </Badge>
    );
  }

  if (!isAccepted && !isRejected && !isInFuture) {
    return (
      <Badge color="red" variant="outline">
        Expired
      </Badge>
    );
  }

  return null;
};
